exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".msg_item_com[data-v-5f98dbda]{padding:10px 0;display:-webkit-box;display:-ms-flexbox;display:flex}.msg_item_com .avatar_wrap[data-v-5f98dbda]{margin-right:10px}\n", ""]);

// exports
